/**
 * YouTube Section Data
 * 
 * Video content for the portfolio's YouTube section.
 * Add new videos by extending this structure or create an array for  videos.
 */
export const youtubeData = {
    title: 'YouTube',
    videos: [
        {
            id: 'Teja\'s Turn',
            episode: 'Teja\'s Turn',
            tagline: 'Alligators, airboats, and swamp adventure in Louisiana.',
            description: 'One of my favorite parts of my Louisiana trip was the swamp tour during St. Patrick\'s Day weekend. With so much going on, it was nice to slow down, get out on the water, and enjoy a quieter side of the place. This video captures some of the best moments from the boat ride, the views, and the overall vibe of the swamp.',
            youtube: {
                id: 'kOyjN7jnzKI',
                url: 'https://www.youtube.com/watch?v=kOyjN7jnzKI'
            }
        },
        {
            id: 'podcast',
            episode: 'RAY RAY · Episode 06',
            tagline: 'International Student Perspectives Across Cultures',
            description: 'This episode features a casual, friendly conversation between international students from India and Nepal. Together, we revisit life before moving to the United States, talk about cultural surprises, and share honest, light-hearted moments from our graduate journey.',
            youtube: {
                id: 'ttGS8tilP1c',
                url: 'https://www.youtube.com/watch?v=ttGS8tilP1c'
            }
        }
    ]
};
